import { isEmpty, isNil, get, has } from 'lodash';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      shareLevelKeys: {
        1: 'common.card.share_level.public',
        2: 'common.card.share_level.private',
      },
    };
  },

  computed: {
    ...mapGetters([
      'subjectMap',
      'gradeMap',
    ]),
  },

  methods: {
    getCoreConceptLabel(coreConcept) {
      if (isNil(coreConcept) || isEmpty(coreConcept)) {
        return null;
      }

      return coreConcept.name;
    },

    getDetailedCoreConceptLabel(coreConcept) {
      if (isNil(coreConcept) || isEmpty(coreConcept)) {
        return null;
      }

      return `${coreConcept.name} (${coreConcept.description})`;
    },

    getSchoolYear(item) {
      return get(item, 'school_year', 0);
    },

    getName(item) {
      return get(item, 'name');
    },

    getTranslatedName(item) {
      if (has(item, 'id')) {
        return this.getName(item);
      }

      return this.$t(this.getName(item));
    },

    getSubjectLabel(item) {
      const name = get(item, 'subject.name');

      if (isNil(name)) {
        return this.getName(this.subjectMap[get(item, 'subject_id')]);
      }

      return name;
    },

    getGradeLabel(item) {
      if (isEmpty(item)) {
        return this.getTranslatedName(this.gradeMap[item]);
      }

      const name = get(item, 'grade.name');

      if (isNil(name)) {
        return this.getTranslatedName(this.gradeMap[get(item, 'grade_id')]);
      }

      return name;
    },

    getGradeSchoolYear(item) {
      const grade = get(item, 'grade') || this.gradeMap[get(item, 'grade_id')];

      return this.getSchoolYear(grade);
    },

    getUnitLabel(unit) {
      if (isNil(unit) || isEmpty(unit)) {
        return null;
      }

      return unit.name;
    },

    getDomainLabel(domain) {
      if (isNil(domain) || isEmpty(domain)) {
        return null;
      }

      return domain.name;
    },

    getShareLevelLabel(shareLevel) {
      if (shareLevel === 1 || shareLevel === 2) {
        return this.$t(this.shareLevelKeys[shareLevel]);
      }

      return '-';
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/labels.js